function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.16,
  y1: 0.16,
  x2: 0.849,
  y2: 0.849,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6e6e6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 0.852,
  y1: 0.852,
  x2: 0.091,
  y2: 0.091,
  xlinkHref: "#a"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2593.107a135.7,135.7,0,1,1-135.7-135.694A135.694,135.694,0,0,1,760.354,2593.107Z",
  opacity: 0
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2592.008a135.7,135.7,0,1,1-135.7-135.7A135.694,135.694,0,0,1,760.354,2592.008Z",
  opacity: 0.083
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2590.906a135.7,135.7,0,1,1-135.7-135.694A135.694,135.694,0,0,1,760.354,2590.906Z",
  opacity: 0.167
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M760.353,2589.8A135.7,135.7,0,1,1,624.659,2454.11,135.693,135.693,0,0,1,760.353,2589.8Z",
  opacity: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2588.705a135.7,135.7,0,1,1-135.7-135.7A135.694,135.694,0,0,1,760.354,2588.705Z",
  opacity: 0.333
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2587.6a135.7,135.7,0,1,1-135.7-135.7A135.694,135.694,0,0,1,760.354,2587.6Z",
  opacity: 0.417
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2586.5a135.7,135.7,0,1,1-135.7-135.695A135.694,135.694,0,0,1,760.354,2586.5Z",
  opacity: 0.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M760.354,2586.5a135.7,135.7,0,1,1-135.7-135.695A135.694,135.694,0,0,1,760.354,2586.5Z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M745.946,2586.5a121.288,121.288,0,1,1-121.287-121.286A121.286,121.286,0,0,1,745.946,2586.5Z",
  fill: "#5d752e"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.936,
  cy: 108.936,
  r: 108.936,
  transform: "matrix(0.11, -0.994, 0.994, 0.11, 504.36, 2682.743)",
  fill: "url(#a)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M728.383,2586.5a103.724,103.724,0,1,1-103.724-103.726A103.726,103.726,0,0,1,728.383,2586.5Z",
  fill: "url(#b)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M593.947,2551.257a8.286,8.286,0,1,1,8.3-8.28A8.294,8.294,0,0,1,593.947,2551.257Zm0-14.858a6.572,6.572,0,1,0,6.582,6.578A6.584,6.584,0,0,0,593.947,2536.4Z",
  fill: "#5d752e"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M605.314,2576.816a3.331,3.331,0,0,1-3.336-3.324V2570.5a.857.857,0,1,1,1.714,0v2.987a1.638,1.638,0,0,0,1.622,1.614,1.721,1.721,0,0,0,1.622-1.68l0-11.626a7.071,7.071,0,0,0-7.067-7.061H588.434a7.069,7.069,0,0,0-7.065,7.061v11.708a1.61,1.61,0,0,0,1.619,1.6,1.638,1.638,0,0,0,1.623-1.614V2570.5a.856.856,0,1,1,1.711,0v2.987a3.334,3.334,0,0,1-6.667.016V2561.8a8.785,8.785,0,0,1,8.779-8.773h11.432a8.786,8.786,0,0,1,8.782,8.773v11.708A3.415,3.415,0,0,1,605.314,2576.816Z",
  fill: "#5d752e"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M602.837,2581.485H585.466a.853.853,0,0,1-.855-.855v-13.3a.855.855,0,1,1,1.711,0v12.443h15.656v-12.443a.857.857,0,0,1,1.714,0v13.3A.853.853,0,0,1,602.837,2581.485Z",
  fill: "#5d752e"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M594.149,2569.566a.854.854,0,0,1-.855-.857v-10.2H591.33a.856.856,0,1,1,0-1.712h5.642a.856.856,0,0,1,0,1.712h-1.966v10.2A.855.855,0,0,1,594.149,2569.566Z",
  fill: "#5d752e"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M642.495,2608.629a8.285,8.285,0,1,1,8.293-8.28A8.293,8.293,0,0,1,642.495,2608.629Zm0-14.854a6.572,6.572,0,1,0,6.579,6.574A6.582,6.582,0,0,0,642.495,2593.775Z",
  fill: "#5d752e"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M637.5,2600.8a8.206,8.206,0,0,1-2.672-.443.856.856,0,1,1,.554-1.619,6.562,6.562,0,0,0,2.118.346,6.492,6.492,0,0,0,5.264-2.632.86.86,0,0,1,1.221-.161,6.733,6.733,0,0,0,5.534,1.315.867.867,0,0,1,1.011.669.853.853,0,0,1-.665,1.009,8.471,8.471,0,0,1-6.264-1.16A8.32,8.32,0,0,1,637.5,2600.8Z",
  fill: "#5d752e"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M653.85,2634.19a3.332,3.332,0,0,1-3.323-3.334v-2.983a.856.856,0,0,1,1.711,0v2.983a1.618,1.618,0,0,0,1.612,1.621,1.716,1.716,0,0,0,1.629-1.68l0-11.627a7.07,7.07,0,0,0-7.062-7.059H636.974a7.066,7.066,0,0,0-7.057,7.059v11.708a1.6,1.6,0,0,0,1.606,1.6,1.623,1.623,0,0,0,1.625-1.621v-2.983a.856.856,0,0,1,1.712,0v2.983a3.329,3.329,0,0,1-6.658.022V2619.17a8.785,8.785,0,0,1,8.772-8.773h11.439a8.787,8.787,0,0,1,8.776,8.773v11.708A3.425,3.425,0,0,1,653.85,2634.19Z",
  fill: "#5d752e"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M651.384,2638.86H634a.852.852,0,0,1-.853-.856v-13.3a.856.856,0,1,1,1.712,0v12.442h15.667V2624.7a.856.856,0,1,1,1.711,0V2638A.854.854,0,0,1,651.384,2638.86Z",
  fill: "#5d752e"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M642.689,2626.94a.859.859,0,0,1-.856-.858v-10.2h-1.952a.857.857,0,1,1,0-1.713h5.626a.857.857,0,1,1,0,1.713h-1.96v10.2A.86.86,0,0,1,642.689,2626.94Z",
  fill: "#5d752e"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M625.17,2589.4a.848.848,0,0,1-.417-.108.861.861,0,0,1-.432-.872l1.733-11.806H618.42a.853.853,0,0,1-.854-.856v-31.309a.853.853,0,0,1,.854-.855h48.549a.857.857,0,0,1,.857.855v31.309a.858.858,0,0,1-.857.856H640.7L625.721,2589.2A.854.854,0,0,1,625.17,2589.4Zm-5.894-14.5h7.768a.862.862,0,0,1,.645.3.872.872,0,0,1,.2.688l-1.547,10.557,13.5-11.339a.86.86,0,0,1,.551-.2h25.719v-29.593H619.276Z",
  fill: "#5d752e"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M648.511,2550.572h-21.4a.855.855,0,1,1,0-1.711h21.4a.855.855,0,1,1,0,1.711Z",
  fill: "#5d752e"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M658.283,2550.572H652.9a.855.855,0,1,1,0-1.711h5.382a.855.855,0,1,1,0,1.711Z",
  fill: "#5d752e"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M589.054,2543.427a8.2,8.2,0,0,1-2.668-.442.856.856,0,1,1,.553-1.621,6.558,6.558,0,0,0,7.38-2.285.859.859,0,0,1,.577-.335.829.829,0,0,1,.644.181,6.659,6.659,0,0,0,5.51,1.313.855.855,0,0,1,.361,1.671,8.182,8.182,0,0,1-1.741.181,8.378,8.378,0,0,1-4.517-1.338A8.209,8.209,0,0,1,589.054,2543.427Z",
  fill: "#5d752e"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M620.343,2627.761H593.064a.857.857,0,0,1-.859-.858v-42.746a.856.856,0,0,1,1.712,0v41.89h26.426a.857.857,0,0,1,0,1.714Z",
  fill: "#5d752e"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M658.283,2555.478H636.878a.857.857,0,0,1,0-1.713h21.405a.857.857,0,1,1,0,1.713Z",
  fill: "#5d752e"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M632.5,2555.478h-5.384a.857.857,0,1,1,0-1.713H632.5a.857.857,0,0,1,0,1.713Z",
  fill: "#5d752e"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M648.511,2560.389h-21.4a.856.856,0,1,1,0-1.713h21.4a.856.856,0,1,1,0,1.713Z",
  fill: "#5d752e"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M658.283,2560.389H652.9a.856.856,0,1,1,0-1.713h5.382a.856.856,0,1,1,0,1.713Z",
  fill: "#5d752e"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M658.283,2565.293H636.878a.858.858,0,0,1,0-1.715h21.405a.858.858,0,0,1,0,1.715Z",
  fill: "#5d752e"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M632.5,2565.293h-5.384a.858.858,0,1,1,0-1.715H632.5a.858.858,0,0,1,0,1.715Z",
  fill: "#5d752e"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M648.511,2570.2h-21.4a.858.858,0,1,1,0-1.715h21.4a.858.858,0,0,1,0,1.715Z",
  fill: "#5d752e"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M658.283,2570.2H652.9a.858.858,0,1,1,0-1.715h5.382a.858.858,0,0,1,0,1.715Z",
  fill: "#5d752e"
});

var SvgPartner5 = function SvgPartner5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271.392,
    height: 277.994,
    viewBox: "0 0 271.392 277.994",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-488.962 -2450.809)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartner5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partner5.b21a53ec.svg";
export { ForwardRef as ReactComponent };